'use strict'

import * as VoxImplant from 'voximplant-websdk'

const sdk = VoxImplant.getInstance()
const config = {
  'language': 'US_ENGLISH_MALE',
  'player': {
    'rate': 'default',
    'volume': 'default'
  }
}
let call = null
let model = null
let savedCommit = null
let savedCommitStack = []
let isConnected = false
let forseStopPlaying = null

const updateConfig = (name, value) => {
  if (!name || !value) {
    return null
  }

  if (name === 'Gender') {
    const oldLang = config.language.split('_')
    config.language = [oldLang[0], oldLang[1], value.toUpperCase()].join('_')
  } else if (name === 'Dialect') {
    const oldLang = config.language.split('_')
    config.language = [value.toUpperCase(), oldLang[1], oldLang[2]].join('_')
  } else if (name === 'Rate') {
    config.player.rate = value
  } else if (name === 'Volume') {
    config.player.volume = value
  }
}

function onSDKReady () {
  sdk.off(VoxImplant.Events.SDKReady, onSDKReady)
  if (!sdk.connected()) {
    sdk.connect(false)
  }
}

function onConnectionEstablished () {
  sdk.off(VoxImplant.Events.ConnectionEstablished, onConnectionEstablished)
  sdk.login(process.env.VOX_API_LOGIN, process.env.VOX_API_PASSWORD)
}

function onAuthResult (e) {
  sdk.off(VoxImplant.Events.AuthResult, onAuthResult)
  if (e.result) {
    call = sdk.call('recognizer', false)
    call.on(VoxImplant.CallEvents.MessageReceived, onCallMessageReceived)
    call.on(VoxImplant.CallEvents.Updated)
  }
}

function onCallMessageReceived (e) {
  if (JSON.parse(e.text).status === 'finished') {
    savedCommit('audioStopped', savedCommitStack.shift())
  }
  forseStopPlaying()
}

function onCallConnected () {
  call.sendMessage(JSON.stringify({ 'command': 'play', 'message': model.body, 'config': config }))
  call.off(VoxImplant.CallEvents.Connected)
}

export default {
  say (outModel, commit, dispatch) {
    model = outModel
    savedCommit = commit

    savedCommitStack.push({...model})

    forseStopPlaying = dispatch

    if (call && call.state() === 'ENDED') {
      call = sdk.call('recognizer', false)
      call.on(VoxImplant.CallEvents.Connected, onCallConnected)
    } else {
      call.sendMessage(JSON.stringify({ 'command': 'play', 'message': model.body, 'config': config }))
    }
  },
  stop () {
    call.sendMessage(JSON.stringify({'command': 'stop'}))
  },
  connect (options) {
    if (isConnected) {
      return true
    }
    isConnected = true
    sdk.on(VoxImplant.Events.SDKReady, onSDKReady)
    sdk.on(VoxImplant.Events.ConnectionEstablished, onConnectionEstablished)
    sdk.on(VoxImplant.Events.AuthResult, onAuthResult)

    sdk.init({
      micRequired: false,
      showDebugInfo: process.env.NODE_ENV !== 'production'
    })
    if (options) {
      options.forEach(option => {
        updateConfig(option.id, option.values[0].id)
      })
    }
  },
  disconnect () {
    if (!isConnected) {
      return true
    }
    isConnected = false
    call.on(VoxImplant.CallEvents.Disconnected, function () {
      call = null
      sdk.disconnect()
    })
    call.hangup()
  },
  updateConfig: updateConfig
}
